module.exports = __webpack_public_path__ + "static/media/GitHub.4b8a4845.svg";